import React, { useState } from 'react';
import { Form, Input, Button, Card, Typography, Space } from 'antd';
import { UserOutlined, LockOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { authService, LoginRequest } from '../services/auth';
import { getMessage } from '../components/PopupModal';

const { Title, Text } = Typography;

const Login: React.FC = () => {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const onFinish = async (values: LoginRequest) => {
    try {
      setLoading(true);
      const response = await authService.login(values);

      if (response.success) {
        navigate('/dashboard');
      } else {
        getMessage().error(response.message || '아이디 또는 비밀번호가 일치하지 않습니다.');
      }
    } catch (err: any) {
      console.error('Login error:', err);
      const errorMessage = err.response?.data?.message || err.message || '아이디 또는 비밀번호가 일치하지 않습니다.';
      getMessage().error(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: '#1f1f1f',
      }}
    >
      <Card
        className="login-card"
        style={{
          width: 400,
        }}
      >
        <Space direction="vertical" size="large" style={{ width: '100%' }}>
          <div style={{ textAlign: 'center' }}>
            <Title level={2} style={{ marginBottom: 8, color: '#ffffff' }}>
              한라에코밸리
            </Title>
            <Text type="secondary" style={{ color: '#a6a6a6' }}>관리자 페이지</Text>
          </div>

          <Form
            name="login"
            onFinish={onFinish}
            onFinishFailed={(errorInfo) => {
              console.log('Form validation failed:', errorInfo);
            }}
            size="large"
            autoComplete="off"
          >
            <Form.Item
              name="username"
              rules={[
                {
                  required: true,
                  message: '아이디를 입력해주세요.',
                },
              ]}
            >
              <Input
                prefix={<UserOutlined />}
                placeholder="아이디"
                autoComplete="username"
              />
            </Form.Item>

            <Form.Item
              name="password"
              rules={[
                {
                  required: true,
                  message: '비밀번호를 입력해주세요.',
                },
              ]}
            >
              <Input.Password
                prefix={<LockOutlined />}
                placeholder="비밀번호"
                autoComplete="current-password"
              />
            </Form.Item>

            <Form.Item>
              <Button
                type="primary"
                htmlType="submit"
                loading={loading}
                style={{ width: '100%' }}
                onClick={(e) => {
                  // Form의 onFinish가 처리하도록 하고, 기본 동작만 방지
                  e.stopPropagation();
                }}
              >
                로그인
              </Button>
            </Form.Item>
          </Form>

          <div style={{ textAlign: 'center' }}>
            <Text type="secondary" style={{ fontSize: '14px', color: '#a6a6a6' }}>
              아이디/비밀번호 분실 시 연락
            </Text>
          </div>
        </Space>
      </Card>
    </div>
  );
};

export default Login;